import { DotSpinner } from '@uiball/loaders';
import React from 'react';
export type DotSpinnerProps = React.ComponentProps<typeof DotSpinner>;
/**
 * A basic spinner (that doesn't do awkward positioning things)
 * @note Can replace `components/Spinner` in follow-up PR,
 *       but placement may need to be adjusted.
 */
export const Spinner = (props: DotSpinnerProps) => (
  <DotSpinner size={16} color="var(--theme_color_content_subtle)" {...props} />
);
